<!-- eslint-disable max-len -->
<route>
{
  "meta": {
    "customSite": false
  }
}
</route>
<template>
  <div class="home">
    <div class="row bg-green-100 pb-20 pt-12 customBg" style="margin-bottom: 0px">
     <div class="site-wrapper h-full">
        <hero-section />
      </div>
    </div>

    <transition
      enter-active-class="transition duration-300 ease-out transform"
      enter-class="scale-95 opacity-0"
      enter-to-class="scale-100 opacity-100"
      leave-active-class="transition duration-150 ease-in transform"
      leave-class="scale-100 opacity-100"
      leave-to-class="scale-95 opacity-0"
    >
      <div v-if="feedPopup" class="absolute inset-0 z-50 h-full bg-black bg-opacity-80">
        <div class="m-auto mt-16 max-w-lg bg-white shadow-2xl">
          <div class="m-auto max-w-xl p-8 text-center sm:px-6">
            <div class="flex justify-end -mt-4 -mr-2">
              <button
                type="button"
                class="items-center text-gray-800 hover:text-gray-500 transition duration-150 ease-in-out"
                @click="closePopup"
              >
                <svg
                  class="w-6 h-6"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path d="M6 18L18 6M6 6l12 12"></path>
                </svg>
              </button>
            </div>
            <h1 class="text-3xl text-base font-extrabold text-black mb-0">
              Start Creating Courses
            </h1>
            <p class="px-20 mx-auto text-lg text-gray-600">
              Get guided onboarding for building and deploying a course on Twitter.
            </p>

            <transition name="show">
              <form
                v-if="!isSubmitted"
                id="apply-form"
                @submit.prevent="applyFeed"
                class="px-6 py-1 space-y-10 text-left"
              >
                <div>
                  <label class="block text-gray-800" for="username">Name</label>
                  <input
                    class="w-full p-2 text-indigo-700 border-b-2 border-gray-500 outline-none focus:bg-gray-100"
                    type="text"
                    required
                    name="name"
                    v-model="name"
                  />
                </div>
                <div>
                  <label class="block text-gray-800" for="email">Email</label>
                  <input
                    class="w-full p-2 text-indigo-700 border-b-2 border-gray-500 outline-none focus:bg-gray-100"
                    type="email"
                    required
                    name="email"
                    v-model="email"
                  />
                </div>
                <div>
                  <label class="block text-gray-800" for="feed">Course Topic</label>
                  <input
                    class="w-full p-2 text-indigo-700 border-b-2 border-gray-500 outline-none focus:bg-gray-100"
                    type="text"
                    required
                    name="feed"
                    v-model="topic"
                  />
                </div>
                <div>
                  <label class="block text-gray-800" for="addn">Additional Details</label>
                  <textarea
                    class="w-full p-2 text-indigo-700 border-b-2 border-gray-500 outline-none focus:bg-gray-100"
                    name="addn"
                    v-model="addn"
                  />
                </div>

                <button
                  type="submit"
                  class="bg-primaryColor rounded-lg text-white px-4 py-3 w-full flex justify-center font-bold text-md cursor-pointer"
                >
                  Submit
                  <label
                    v-if="formSubmitting"
                    class="animate-spin h-5 w-5 mr-3 border-t-2 border-l-2 rounded-full"
                  ></label>
                </button>
              </form>
              <div v-if="isSubmitted" class="px-6 py-1 space-y-10 text-left">
                <div class="flex justify-center">
                  <h1 class="text-3xl text-base font-extrabold text-green-400 mb-0 text-center">
                    Success! You will hear back from us soon.
                  </h1>
                </div>
                <div class="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2">
                  <div class="sm:col-span-1">
                    <dt class="text-sm font-medium text-gray-500">Name</dt>
                    <dd class="mt-1 text-sm text-gray-900">{{ this.name }}</dd>
                  </div>
                  <div class="sm:col-span-1">
                    <dt class="text-sm font-medium text-gray-500">Email</dt>
                    <dd class="mt-1 text-sm text-gray-900">
                      {{ this.email }}
                    </dd>
                  </div>
                  <div class="sm:col-span-1">
                    <dt class="text-sm font-medium text-gray-500">Course</dt>
                    <dd class="mt-1 text-sm text-gray-900">
                      {{ this.topic }}
                    </dd>
                  </div>
                  <div class="sm:col-span-2">
                    <dt class="text-sm font-medium text-gray-500">Additional Details</dt>
                    <dd class="mt-1 text-sm text-gray-900">
                      {{ this.addn }}
                    </dd>
                  </div>
                </div>
                <button
                  class="bg-secondaryColor rounded-lg text-white px-4 py-3 w-full font-bold text-md"
                  @click.prevent="closePopup"
                >
                  Done
                </button>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </transition>

    <div style="display: table; clear: both"></div>

    <div class="relative bg-white py-6 sm:py-12 site-wrapper">
      <div class="discoverBg z-10"></div>
      <div class="mx-auto max-w-xl px-4 sm:max-w-3xl sm:px-6 lg:px-2 lg:max-w-full">
        <h1 class="hidden text-base text-left font-extrabold tracking-tight text-black">
          Key features
        </h1>
        <div class="mt-6">
          <div class="grid grid-cols-1 gap-8 lg:grid-cols-3">
            <div
              v-for="(item, index) in features"
              :key="index"
              class="pt-6 shadow-xl rounded-xl hover:no-underline bg-white z-20"
            >
              <div class="flow-root bg-gray-50 rounded-lg px-6 pb-4">
                <div class="-mt-6">
                  <div class="w-20 pt-3 mx-auto">
                    <img :src="item.icon" alt="Browser by Omar Safaa from the Noun Project" />
                  </div>
                  <h3 class="mt-0 text-xl font-bold text-black tracking-tight text-center">
                    {{ item.title }}
                  </h3>
                  <p class="mb-0 text-md text-gray-800 tracking-tight">
                    {{ item.detail }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!---------------------------------------------- key fetures section  start------------------ -->
    <div id="courses" class="row bg-green-100 mb-0">
      <div class="relative py-12 sm:py-24 lg:py-28 site-wrapper">
        <!-- wrapper div for max width and padding start -->
        <div v-for="(item, index) in keyFeatures" :key="index" class="mx-auto max-w-xl px-4 sm:max-w-3xl sm:px-6 lg:px-2 lg:max-w-full">
           <section :class="[index===0?'mt-0':'mt-10']">
            <FeatureSection :title="item.title" :desc="item.detail" :imgPath="item.img" :isReverse="index%2==0" />
           </section>
          <div class="flex justify-center pt-6">
            <button
              class="hidden bg-secondaryColor rounded-lg text-white px-6 py-2 font-bold text-md hover:no-underline"
            >
              View all
            </button>
          </div>
        </div>
        <!-- wrapper div for max width and padding end -->
      </div>
    </div>
      <!---------------------------------------------- key fetures section  end------------------ -->

    <div class="row bg-blue-100 pb-20 pt-20 border border-gray-500 md:border-none" style="margin-bottom: 0px">
      <div class="site-wrapper h-full">
        <MonologueSection
         title="Broadcast marketing is the path to failure."
         imgPath="personalized-segments.png"
        />
      </div>
    </div>
    <!-- pricint section  -->
    <div class="row bg-white pb-20 pt-20 max-w-screen-xl mx-auto">
      <div class=" lg:px-5 xl:px-16 h-full">
        <pricing-table  />
      </div>
    </div>
    <!-- pricint section end  -->
    <div class="row mb-0 bg-green-100">
      <div class="flex flex-col h-full site-wrapper py-10">
        <h1 class="text-center text-4xl font-extrabold text-tighten mb-0">
          What the Experts are Saying
        </h1>
        <p class="hidden text-center text-xl text-gray-700 mb-0">
          We have been working with clients around the world
        </p>
        <div
          class="grid grid-cols-1 gap-8 justify-content-center sm:grid-cols-2 lg:grid-cols-3 text-center"
        >
          <div v-for="item in testimonials" :key="item.name" class="pt-6 z-20">
            <div class="bg-white flow-root bg-gray-50 rounded-lg px-6 pb-4">
              <div class="mt-3">
                <h3 class="hidden text-xl font-bold text-black tracking-tighter">
                  {{ item.reviewHeading }}
                </h3>
                <p class="text-md text-gray-700">
                  {{ item.review }}
                </p>
              </div>
            </div>
            <div class="mt-3 flex-row justify-center">
              <img class="inline-block h-12 w-12 rounded-full" :src="item.pic" :alt="item.name" />
              <h3 class="mt-2 text-lg font-bold text-black tracking-tighter mb-0">
                {{ item.name }}
              </h3>
              <h5 class="text-md text-gray-700">{{ item.designation }}</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*.customBg {
  background-image: url(/img/bg_banner.png);
  background-repeat: no-repeat;
  background-size: 100vh 415px;
  background-position-y: bottom;
  background-position-x: right;
}

@screen md {
  .customBg {
    background-position: center;
    background-size: cover;
  }
}*/
.discoverBg {
  position: absolute;
  top: 10px;
  right: -100px;
  border-radius: 50%;
  background-color: #90a1d638;
  min-width: 450px;
  min-height: 450px;
}
.secondary-back {
  /*background-color: #7CA8C1;*/
  /*background-color: #E9EBEE;*/
  /* background-color: $primary-light; */
  background-color: #c9d99e;
}

#illustration {
  background-image: url(/img/hero-illustration.png);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  float: left;
  width: 100%;
  margin-left: -25px;
  height: 100%;
}

#illustration1 {
  background-image: url(/img/recap_banner.png);
  background-repeat: no-repeat;
  background-position: center;
  float: left;

  width: 100%;
  margin-left: -25px;
  height: 415px;
}

input:focus-within ~ label,
input:not(:placeholder-shown) ~ label {
  @apply transform scale-75 -translate-y-6;
}

input:focus-within ~ label {
  @apply text-blue-500;
}

.outline input:focus-within ~ label,
.outline input:not(:placeholder-shown) ~ label {
  @apply transform scale-75 -translate-y-4 z-0 ml-0 px-1 py-0;
}

.show-enter-active,
.show-leave-enter {
  transform: translateX(0);
  transition: all 0.3s linear;
}
.show-enter,
.show-leave-to {
  transform: translateX(10%);
}

@screen md {
  #illustration {
    width: 100%;
    display: block;
  }
}
#main-msg .form-box {
  float: left;
  max-width: 375px;
  /* background-color: white; */
  /* padding: 0px 24px; */
  border-radius: 3px;
  margin-top: 10px;
  margin-bottom: 15px;
}
#main-msg .form-box a {
  color: #206f45;
}

#home-about h2 {
  margin-top: 15px;
  margin-bottom: 5px;
}
#home-about {
  @apply mb-0;
}

#main-msg .form-box p {
  font-size: 14px;
  margin-top: 10px;
  text-align: center;
}
#main-msg .form-box label {
  display: block;
  margin-top: 10px;
}
#main-msg .form-box input[type='submit'] {
  /*background-color: #298c57;*/
  /* background-color: $brand-color; */
  /* TODO: TailWind test that this works */
  @apply bg-primaryColor;
  padding: 10px 16px;
  font-size: 18px;
  /* border-top-right-radius: 6px;
    border-bottom-right-radius: 6px; */
  border-radius: 6px;
  color: white;

  margin-top: 10px;
  width: 100%;
}
#main-msg .form-box input[type='email'],
#main-msg .form-box input[type='text'] {
  padding: 10px 16px;
  box-sizing: border-box;
  width: 100%;
}
.mc-field-group,
#mce-responses {
  position: relative;
  padding-top: 10px;
}
.mc-field-group div.mce_inline_error {
  position: absolute;
  top: -24px;
  /* left: 40px; */
}
#mce-responses div#mce-success-response {
  /* position: absolute; */
  /* top: 135px; */
  font-weight: bold;
  font-size: 150%;
}
h1#prod-desc {
  /* text-align: center; */
  margin-bottom: 20px;
  /* color: #298c57; */
}

.info-col {
  width: 255px;
  /* text-align: center; */
  font-size: 16px;
  margin-bottom: 30px;

  margin-left: auto;
  margin-right: auto;
}
@screen sm {
  .info-col {
    @apply float-left mx-4;
  }
}

.info-col img {
  width: 50px;
}

.info-col h3 {
  /* color: theme('colors.primaryColor'); */
  font-weight: bold;
  margin-bottom: 10px;
  /* font-size: 1.5em; */
}

/* #topicButtons { */
#topicButtons section {
  float: left;
  height: 175px;
  width: 195px;
  position: relative;
  padding: 15px;
  border-radius: 8px;
  background-color: #19293a;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  margin-right: 25px;

  color: white;
}
#topicButtons section a {
  color: #fbe8c7;
}

#topicButtons section div {
  position: absolute;
  bottom: 15px;
  left: 15px;
  right: 15px;
}

/* carousel function */
#topicButtons #carousel {
  overflow: auto;
  scroll-behavior: smooth;
  display: grid;
  grid-auto-flow: column;
}

/* carousel appearance */
#topicButtons #carousel {
  padding: 10px;
}
#topicButtons #prev,
#next {
  outline: none;
  padding: 8px;
  border-radius: 50%;
}

/* position the buttons */
#topicButtons {
  position: relative;
}
#topicButtons #prev,
#next {
  position: absolute;
  top: 50%;
}
#topicButtons #prev {
  left: 0;
  transform: translate(50%, -50%);
}
#topicButtons #next {
  right: 0px;
  transform: translate(-50%, -50%);
}

/* initial state */
#topicButtons #prev {
  display: none;
}

.quote {
  max-width: 650px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 30px;
  font-size: 18px;
  border-left: 10px solid #8f9fd6;
  padding-left: 10px;
}

.rotate-wrapper {
  position: relative;
  /* margin: 110px auto 0 auto; */
  /* padding: 10px; */

  /*width to make sure layout with longest phrase, i.e. 'Content Marketing' works.*/
  width: 230px; /*2-row - since mobile is the default*/
}
@screen sm {
  .rotate-wrapper {
    width: 350px; /* 2-row - since the font gets bigger here */
  }
}
@screen md {
  .rotate-wrapper {
    width: 100%;
    /* width: 505px; // <-- on-palm */
    /* width: 755px; // <-- on-laptop */
  }
}
.rotate-words {
  display: inline-block;
}
.rotate-words span {
  max-width: 0;
  display: inline-block;
  opacity: 0;
  /* overflow: hidden; */
  color: #298c57;
  animation: rotateWord 18s linear infinite 0s;
}
.rotate-words span:nth-child(2) {
  animation-delay: 3s;
}
.rotate-words span:nth-child(3) {
  animation-delay: 6s;
}
.rotate-words span:nth-child(4) {
  animation-delay: 9s;
}
.rotate-words span:nth-child(5) {
  animation-delay: 12s;
}
.rotate-words span:nth-child(6) {
  animation-delay: 15s;
}
@keyframes rotateWord {
  2% {
    opacity: 0;
    transform: translateY(-30px);
  }
  5% {
    opacity: 1;
    transform: translateY(0px);
  }
  17% {
    opacity: 1;
    transform: translateY(0px);
  }
  20% {
    opacity: 0;
    transform: translateY(30px);
  }
  80% {
    opacity: 0;
  }
}
</style>

<!-- eslint-disable-next-line max-len -->
<script
  type="text/javascript"
  src="//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js"
></script>
<script type="text/javascript">
(function ($) {
  window.fnames = new Array();
  window.ftypes = new Array();
  fnames[1] = 'FNAME';
  ftypes[1] = 'text';
  fnames[2] = 'LNAME';
  ftypes[2] = 'text';
  fnames[0] = 'EMAIL';
  ftypes[0] = 'email';
  fnames[3] = 'ADDRESS';
  ftypes[3] = 'address';
  fnames[4] = 'PHONE';
  ftypes[4] = 'phone';
  fnames[5] = 'BIRTHDAY';
  ftypes[5] = 'birthday';
  fnames[6] = 'FULLNAME';
  ftypes[6] = 'text';
})(jQuery);
var $mcj = jQuery.noConflict(true);
</script>

<script>
import admin from '@implicit-web/implicit.io/src/services/admin.js';
import store from '@/store';
import FeatureSection from '@/components/Home/FeatureSection.vue';
import MonologueSection from '@/components/Home/MonologueSection.vue';
import HeroSection from '../components/Home/HeroSection.vue';
import HomePricingTable from '../components/Home/HomePricingTable.vue';
import PricingTable from '../components/Home/New/PricingTable.vue';

export default {
  name: 'Home',
  layout: 'null',
  components: {FeatureSection, MonologueSection, HeroSection, HomePricingTable, PricingTable},
  data() {
    return {
      formSubmitting: false,
      name: '',
      email: '',
      topic: '',
      addn: '',
      isSubmitted: false,
      features: [
        {
          title: 'Gain Followers Smartly',
          detail:
            'Support people with your audience. Reply and grow fans together. Get followers that will engage.',
          icon: '/img/noun-social-509343.svg',
        },
         {
          title: 'Twitter Friends Delivered',
          detail:
            'Get automatically created lists of friends, fans, and mentors. See their newest posts. Quickly reply to them.',
          icon: '/img/noun-networking-2909312.svg',
        },
        //  {
        //   title: 'Sell the Twitter way',
        //   detail:
        //     'Never drop a conversation. Manage leads and follow up with reminders, notes, and integrated DMs.',
        //   icon: '/img/noun-money-talk-348119.svg',
        // },
        //  {
        //   title: 'Understand what works',
        //   detail:
        //     'See what your audience enjoys with built-in DM polls and engagement tracking.',
        //   icon: '/img/noun-chart-4743285.svg',
        // },
        {
          title: 'Build Raving Fans',
          detail:
            'Go from replies to DMs and get people to share their problems. All from a super simple dashboard.',
          icon: '/img/noun-segment-4275172.svg',
        },
        // {
        //   title: 'Make every purchase count',
        //   detail:
        //     'Quickly check in on customers. Get them using your product. Find stumbling points and share tips.',
        //   icon: '/img/noun-after-work-5127898.svg',
        // },
      ],
      activeTestimonial: 0,
      testimonials: [
        {
          name: 'Arvid Kahl',
          designation: 'Owner, The Bootstrapped Founder',
          pic: 'https://pbs.twimg.com/profile_images/1201525049766883328/QPimCC9z_400x400.jpg',
          review:
            `Chat with people about the things they care about. They'll start caring about you, too.`,
          reviewHeading: 'Rocking!!',
        },
        {
          name: 'Amanda Natividad',
          designation: 'VP Marketing, SparkToro',
          pic: 'https://pbs.twimg.com/profile_images/1473404504296939521/OEZNArh9_400x400.jpg',
          review:
            'Marketing is a never-ending journey of learning pain points and caring about solving them.',
          reviewHeading: 'Productive!!',
        },
        {
          name: 'Rob Lennon',
          designation: '45x Published Author',
          pic: 'https://pbs.twimg.com/profile_images/1524905043786289152/JSpEMKHS_400x400.png',
          review:
            'Don’t expect to meet your dream client overnight. It takes time to build trust and relationships.',
          reviewHeading: 'Excellent!!',
        },
      ],
      keyFeatures: [
        {
          title: 'Connect quickly and without the hassle.',
          detail:
            `Replying to lots of people is hard. Getting those people into DMs is even harder.\n\n Implicit lets you do both with ease. \n\nIt shows you important posts first and lets you move from replies to DMs with a single click.`,
          img: 'ConnectDMs.png',
        },
        {
          title: 'Find people interested in you.',
          detail:
            `Twitter brings you disorganized traffic. Implicit helps you make sense of it.\n\n Gather fans from every side of Twitter: \n- Previous interactions\n- Engagements on a Tweet\n- Giveaways\n\nPut them in easy-to-access lists, where you can engage and understand their pains. Without sounding like a bot.`,
          img: 'AddMemberModal.png',
        },
        {
          title: 'Focus on those that matter with powerful lists.',
          detail:
            'Ever wanted to know who’s engaging with your content but you haven’t DMd?\n\nOr who’s in a list that you can actually send DMs to?\n\nImplicit’s list building tools enable that and more.',
          img: 'QueryFilter.png',
        },
        // {
        //   title: 'Build relationships on autopilot',
        //   detail:
        //     'Implicit lets you to create automations that allow you to run drip campaigns, administer courses, tell people about product launches, and much more. \n \n Getting everything you create more eyes, and building relationships in the process.',
        //   img: 'Sequences.png',
        // },
      ],
    };
  },
  mounted() {
    const scrollAmt = 200 + 25;
    if(this.$route.query.setFeedPopup)
    {
      this.setFeedPopup(true)
      this.$router.replace({ path: '/', query: {} })
    }
    if(this.$route.query.product)
    {
      this.gotoCourses()
      this.$router.replace({ path: '/', query: {} })
    }
    const carousel = document.getElementById('carousel'),
      // content = document.getElementById('content'),
      next = document.getElementById('next'),
      prev = document.getElementById('prev');
    if (carousel) {
      carousel.addEventListener('scroll', (e) => {
        if (carousel.scrollLeft == 0) {
          prev.style.display = 'none';
        } else {
          prev.style.display = 'inherit';
        }
        if (carousel.scrollWidth == carousel.scrollLeft + carousel.clientWidth) {
          next.style.display = 'none';
        } else {
          next.style.display = 'inherit';
        }
      });
    }
    if (next) {
      next.addEventListener('click', (e) => {
        carousel.scrollBy(scrollAmt, 0);
      });
    }
    if (prev) {
      prev.addEventListener('click', (e) => {
        carousel.scrollBy(-scrollAmt, 0);
      });
    }

    // window.addEventListener('resize', e => (width = carousel.offsetWidth));
  },
  methods: {
    setActiveTestimonial(index) {
      this.activeTestimonial = index;
    },
    gotoCourses() {
      window.scrollTo(0, document.querySelector('#courses').scrollHeight + 250);
    },
    setFeedPopup(isOpen) {
      store.commit('updateFeedPopup', isOpen);
    },
    async applyFeed() {
      this.formSubmitting = true;
      const data = {
        name: this.name,
        email: this.email,
        topic: this.topic,
        addn: this.addn,
        type: 'implicit',
      };
      await admin.submitMemberRequest(data);
      this.isSubmitted = true;
      this.formSubmitting = false;
    },
    closePopup() {
      store.commit('updateFeedPopup', false);
      this.isSubmitted = false;
      this.name = '';
      this.email = '';
      this.topic = '';
      this.addn = '';
    },
  },
  computed: {
    feedPopup: function () {
      return store.state.feedPopup;
    },
  },
};
</script>
